import { Serializable } from './Serializable';

export class HomeDTO extends Serializable {
    
    finalizedPolls: number;
    inProgressPolls: number;
    currentParticipation: number;
    newComments: number;
    strongKeyDriverName: string;
    strongKeyDriverValue: number
    opportunityKeyDriverName: string;
    opportunityKeyDriverValue: number;
    mostImprovedKeyDriverName: string;
    mostImprovedKeyDriverValue: number;
    toImproveKeyDriverName: string;
    toImproveKeyDriverValue: number;
    phrase: string;

    constructor() {
        super();
    }

    currentParticipationRounded() {
        if (this.currentParticipation)
            return Math.round(this.currentParticipation);
        return 0;
    }

}
